import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { formValueSelector, change } from 'redux-form';
import * as actionCreators from 'actions/EntityCRUD';

import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import pallet from '../../constants/colors';

const styles = {
  container: {
    marginTop: 14,
  },
  button: {
    cursor: 'pointer',
    userSelect: 'none',
    outline: 'none',
    color: pallet.primary1Color,
  },
};

class AddOpitonInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      inputValue: '',
    };
  }

  onInputChange = ev => this.setState({ inputValue: ev.target.value });
  createOption = () => {
    const {
      entity,
      entityField,
      entityForm,
      entityLink,
      onSave,
      create,
      inputField,
      lookupValue,
    } = this.props;
    const { inputValue } = this.state;
    create(entity, {
      [inputField]: inputValue,
      [entityLink]: lookupValue,
    }, newEntity => change(entityForm, entityField, newEntity[`${entity}ID`] || 0));
    this.closeOptionDialog();
    onSave && onSave();
  }

  openOptionDialog = () => this.setState({ dialogOpen: true, inputValue: '' });
  closeOptionDialog = () => this.setState({ dialogOpen: false, inputValue: '' });

  render() {
    const { dialogOpen, inputValue } = this.state;
    const { label } = this.props;
    const actions = [
      <FlatButton
        secondary
        onClick={this.closeOptionDialog}
        label={<FormattedMessage id="addOption.cancel" />}
      />,
      <FlatButton
        primary
        onClick={this.createOption}
        disabled={!inputValue.length}
        label={<FormattedMessage id="addOption.add" />}
      />,
    ];
    return (
      <div style={styles.container}>
        <Dialog
          actions={actions}
          open={dialogOpen}
        >
          <TextField
            onChange={this.onInputChange}
            value={inputValue}
            hintText={
              <FormattedMessage id="addOption.placeholder" values={{ label }} />
            }
            fullWidth
          />
        </Dialog>
        <div style={styles.button} role="button" onKeyDown={() => null} tabIndex="0" onClick={this.openOptionDialog}>
          <FormattedMessage id="addOption.action" values={{ label }} />
        </div>
      </div>
    );
  }
}

AddOpitonInput.propTypes = {
  label: PropTypes.node.isRequired,
  entity: PropTypes.string.isRequired,
  entityField: PropTypes.string,
  entityForm: PropTypes.string,
  entityLink: PropTypes.string,
  inputField: PropTypes.string,
  lookupValue: PropTypes.any,
  onSave: PropTypes.func,
  create: PropTypes.func,
};

export default connect(
  (state, wrapperProps) => {
    // If we have no link to worry about we do not need to fetch a value form the form
    if (!wrapperProps.entityForm || !wrapperProps.entityLookup) {
      return {};
    }
    const selector = formValueSelector(wrapperProps.entityForm);
    return {
      lookupValue: selector(state, wrapperProps.entityLookup),
    };
  },
  actionCreators,
)(AddOpitonInput);



// WEBPACK FOOTER //
// ./src/components/form/AddOptionInput.js